import { useMemo } from 'react';
import { SelectOption } from '@web-for-marketing/react-ui';
import { useLazyLoadedSelectOptions, LazyLoadedSelectOptionsTypes } from '@hooks/useLazyLoadedSelectOptions';
import { useTranslation } from '@stateManagement/TranslationContext';
import { getTranslation } from '@helpers/languageTranslations';
import { DropdownType } from '@models/customForm';

function getOptionType(countryCode: string): LazyLoadedSelectOptionsTypes[] {
    if (countryCode === 'CA') {
        return [DropdownType.CanadianProvince];
    } else if (countryCode === 'US') {
        return [DropdownType.AmericanState];
    } else if (countryCode === 'BR') {
        return [DropdownType.BrazilianState];
    }
    return [];
}

export function useProvinceStateDropdown(countryCode: string): [boolean, string, string, SelectOption[]] {
    const isCountryUS = countryCode === 'US';
    const isCountryCA = countryCode === 'CA';
    const isCountryBR = countryCode === 'BR';
    const { selectedLanguageTranslation } = useTranslation();
    const formTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formTranslations');
    }, [selectedLanguageTranslation]);
    const placeholderTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formPlaceholders');
    }, [selectedLanguageTranslation]);

    const optionType: LazyLoadedSelectOptionsTypes[] = useMemo(() => getOptionType(countryCode), [countryCode]);
    let label = '';
    let placeholder = '';
    let showDropdown = false;

    if (isCountryUS || isCountryBR) {
        label = formTranslations?.state || 'State';
        placeholder = placeholderTranslations?.statePlaceholder || 'Select a state';
        showDropdown = true;
    }

    if (isCountryCA) {
        label = formTranslations?.province || 'Province';
        placeholder = placeholderTranslations?.provincePlaceholder || 'Select a province';
        showDropdown = true;
    }

    const [options] = useLazyLoadedSelectOptions(optionType);

    return [showDropdown, label, placeholder, options || []];
}
